export default {
  COUNTRY: "country",
  ZIP_CODE: "postal_code",
  CITY: "locality",
  POSTAL_TOWN: "postal_town",
  STREET: "route",
  STREET_NUMBER: "street_number",
  NEIGHBORHOOD: "neighborhood",
  PROPERTY_NAME_SHORT_NAME: "short_name",
};